var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.14307H2.5C1.67157 3.14307 1 3.81464 1 4.64307V11.6431C1 12.4715 1.67157 13.1431 2.5 13.1431H13.5C14.3284 13.1431 15 12.4715 15 11.6431V4.64307C15 3.81464 14.3284 3.14307 13.5 3.14307Z",
    stroke: "#606060",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.14307V2.14307C4.5 1.87785 4.60536 1.6235 4.79289 1.43596C4.98043 1.24842 5.23478 1.14307 5.5 1.14307H10.5C10.7652 1.14307 11.0196 1.24842 11.2071 1.43596C11.3946 1.6235 11.5 1.87785 11.5 2.14307V3.14307M15 6.64307H1M10 6.64307V7.39307C10 7.45937 9.97366 7.52296 9.92678 7.56984C9.87989 7.61673 9.8163 7.64307 9.75 7.64307H6.25C6.1837 7.64307 6.12011 7.61673 6.07322 7.56984C6.02634 7.52296 6 7.45937 6 7.39307V6.64307",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMallet);
export default __webpack_public_path__ + "static/media/icon-mallet.1e51c7338ce7e079d586c81743589379.svg";
export { ForwardRef as ReactComponent };